"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runNpcUpdate = runNpcUpdate;
const ScriptEvaluator_1 = require("./ScriptEvaluator");
const npcCharacter_1 = require("../utils/npcCharacter");
const EffectTracker_1 = require("./EffectTracker");
/**
 * Resolve adventure, validate NPC definition, and run its inline `update` script.
 * Safe to call from tick loops: logs and skips on missing script or errors.
 */
const emptyEffect = () => (0, EffectTracker_1.emptyEffectResult)();
function runNpcUpdate(npcId, adventure, deps) {
    if (!adventure) {
        return emptyEffect();
    }
    const character = adventure.getCharacter(npcId);
    if (!(0, npcCharacter_1.isNpcDefinition)(character)) {
        return emptyEffect();
    }
    const script = (0, npcCharacter_1.getInlineNpcUpdateScript)(character);
    if (!script) {
        if (character?.updateScriptId && String(character.updateScriptId).trim() !== '') {
            console.warn(`[runNpcUpdate] NPC '${npcId}' has updateScriptId but lazy-loaded scripts are not implemented yet; skipping.`);
        }
        return emptyEffect();
    }
    return ScriptEvaluator_1.ScriptEvaluator.executeNpcUpdate(script, npcId, deps.gameSession, deps.variableStore, deps.adventureManager, deps.friendsService, deps.adventureInviteService, deps.asyncOperationService, deps.inviteLinkService, { getNowMs: deps.getNowMs, onUpdateFailure: deps.onUpdateFailure });
}
//# sourceMappingURL=runNpcUpdate.js.map